import L from 'leaflet';
let numeral = require('numeral');

export default class Marker {

    constructor(toPoint, customMarkerOptions = {}) {

        let markerOptions = {
            location: toPoint,
            radius: 3,
            weight: 1,
            fillColor: '#ffffff',
            opacity: 1,
            fillOpacity: 1,
            stroke: true
        };

        switch(customMarkerOptions.type) {
            case 'start':
                Object.assign(markerOptions, Marker.start(toPoint));
                break;
            case 'end':
                Object.assign(markerOptions, Marker.end(toPoint));

                break;
            default:
                Object.assign(markerOptions, customMarkerOptions);
        }

        let marker;
        if (markerOptions.icon) {
            markerOptions.icon = L.divIcon(markerOptions.icon);
            marker = L.marker(toPoint.latLng, markerOptions);
        } else {
            marker = L.circleMarker(toPoint.latLng, markerOptions);
        }

        let popup = markerOptions.popup;
        if (popup) {
            marker.bindPopup(popup.content, popup);
            marker.on({
                'mouseover': function(e) {
                    e.target.openPopup();
                },
                'mouseout': function(e) {
                    e.target.closePopup();
                }
            });
        }

        return marker;
    }

    static start(point) {
        return {
            radius: 10,
            icon: {
                type: 'div',
                iconSize: [20, 20],
                className: 'start-marker',
                iconAnchor: [10, 10]
            },
            popup: {
                content: Marker.renderHistoryPopup(point),
                className: 'history-popup'
            },
            zIndexOffset: 95000
        };
    }

    static end(point) {
        return {
            radius: 10,
            icon: {
                type: 'div',
                 iconSize: [18, 18],
                className: 'end-marker',
                iconAnchor: [9, 9],
            },

            popup: {
                content: Marker.renderHistoryPopup(point),
                className: 'history-popup'
            },
            zIndexOffset: 95000
        };
    }

    static lastEnd(point) {
        return {
            radius: 10,
            icon: {
                type: 'div',
                 iconSize: [18, 18],
                className: 'end-marker',
                iconAnchor: [9, 9],
            },

            popup: {
                content: Marker.renderHistoryPopup(point),
                className: 'history-popup'
            },
            zIndexOffset: 95000
        };
    }

    // Add other parameters, receive only 1 parameter: location with all attributes
    static renderHistoryPopup(point) {
        return '<div class="row">' +
            `<div class="col-md-12"><strong>Time:</strong> ${point.time.format('L LTS')}</div>` +
            `<div class="col-md-12"><strong>Speed:</strong> ${point.speed} km/h</div>` +
            (point.alt ? `<div class="col-md-12"><strong>Alt:</strong> ${point.alt} m</div>` : '') +
            (point.fuel ? `<div class="col-md-12"><strong>Fuel:</strong> ${point.fuel} l</div>` : '') +
            (point.dfm ? `<div class="col-md-12"><strong>DFM:</strong> ${numeral(point.dfm).format('0,0.00')} km</div>` : '') +
            `<div class="col-md-12"><strong>DFZ:</strong> ${numeral(point.dfz).format('0,0')} km</div>` +
            (point.dfr ? `<div class="col-md-12"><strong>DFR:</strong> ${numeral(point.dfr).format('0,0.00')} km</div>` : '') +
            '</div>';
    }
}
